import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'failed-action-dialog',
  templateUrl: './failed-action-dialog.component.html',
  styleUrls: ['./failed-action-dialog.component.scss']
})
export class FailedActionDialogComponent implements OnInit {

  errorDetails: any;

  constructor(public dialogRef: MatDialogRef<FailedActionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.errorDetails = this.data.responseMessage ? this.data.responseMessage : this.data.defaultMessage;
  }

  ok(): void {
    this.dialogRef.close();
  }
}
